<!-- Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. -->

<form [formGroup]="formGroup" mat-dialog-content (ngSubmit)="onNext()">
	<div
		class="validation-results-content"
		*ngIf="validateImportTicketsData$ | async as validateImportTicketsData"
	>
		<div
			*ngIf="
				validateImportTicketsData.lastError?.errorType !== TicketImportErrorType.UNRECOVERABLE;
				else missingColumnsError
			"
		>
			<h3>{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_TITLE }}</h3>
			<div>
				{{
					appStrings.IMPORT_TICKET_VALIDATION_STEP_ERROR_TEXT(validateImportTicketsData.lastError.errorCount)
				}}
			</div>
			<div>
				{{
					appStrings.IMPORT_TICKET_VALIDATION_STEP_WARNING_TEXT(
						validateImportTicketsData.lastError.warningCount
					)
				}}
			</div>
			<ol class="validation-results-indication-list">
				<li>{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_INDICATION_1 }}</li>
				<li>{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_INDICATION_2 }}</li>
			</ol>
			<p>{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_WARNING_VERBIAGE }}</p>
		</div>
		<ng-template #missingColumnsError>
			<div>
				<h3>{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_TITLE }}</h3>
				<div>
					{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_ERROR_TEXT }}
					{{ validateImportTicketsData.lastError.errorDescription }}
				</div>
				<ol class="validation-results-indication-list">
					<li>{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_INDICATION_1 }}</li>
					<li>{{ appStrings.IMPORT_TICKET_VALIDATION_STEP_MISSING_COLUMNS_INDICATION_2 }}</li>
				</ol>
			</div>
		</ng-template>
		<button
			*ngIf="
				!!validateImportTicketsData.issuesUrl &&
				(validateImportTicketsData.lastError.errorCount > 0 ||
					validateImportTicketsData.lastError.warningCount > 0)
			"
			class="download-sample-button"
			(click)="onDownloadErrorWarningsFile(validateImportTicketsData.issuesUrl)"
			mat-stroked-button
			type="button"
			color="primary"
		>
			{{
				validateImportTicketsData.lastError.errorCount > 0
					? appStrings.IMPORT_TICKET_VALIDATION_STEP_DOWNLOAD_ERRORS_BUTTON
					: appStrings.IMPORT_TICKET_VALIDATION_STEP_DOWNLOAD_WARNINGS_BUTTON
			}}
		</button>
		<div>
			<mat-form-field class="file-upload">
				<tp-file-upload
					fileUploadSingle
					formControlName="importFile"
					[buttonText]="appStrings.IMPORT_TICKETS_BUTTON_TEXT"
					[placeholder]="appStrings.IMPORT_TICKETS_FILE_PLACEHOLDER"
					[outputFormat]="UploadOutputFormat.File"
					[acceptedFileTypes]="ticketImportSupportedFormats"
				>
				</tp-file-upload>
				<mat-hint *ngIf="(ticketImportFileUploadStatus$ | async) === ticketImportFileUploadStatus.Success">
					{{ appStrings.IMPORT_TICKETS_FILE_UPLOAD_SUCCESS }}
				</mat-hint>
				<mat-error *ngIf="importFileFormControl.hasError('dataFormatIncorrect')">
					{{ appStrings.IMPORT_TICKETS_TEMPLATE_INVALID_FORMAT }}
				</mat-error>
			</mat-form-field>
		</div>
	</div>
</form>

<mat-divider class="padded-divider"></mat-divider>

<!-- Footer -->
<button-footer
	mat-dialog-actions
	(buttonSaveOrClose)="onNext()"
	[saveOrCloseButtonText]="appStrings.UICONTROL_TEXT_NEXT | uppercase"
>
	<!-- BEGIN PLACEHOLDER REPLACE AS PART OF TP-5850 -->
	<!-- <button type="button" middleButton mat-stroked-button color="primary" (click)="onBack()">
		{{ appStrings.UICONTROL_TEXT_BACK }}
	</button> -->
	<!-- END PLACEHOLDER REPLACE AS PART OF TP-5850 -->
	<button leftButton type="button" mat-button mat-dialog-close color="primary" automationId="cancel">
		{{ appStrings.UICONTROL_TEXT_CANCEL.toUpperCase() }}
	</button>
</button-footer>
